export function splitWords(el: HTMLElement): void {
  const tmp = document.createElement("div");
  tmp.innerHTML = el.innerHTML;

  function walk(node: Node): void {
    Array.from(node.childNodes).forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        const frag = document.createDocumentFragment();
        const parts = (child.textContent ?? "").split(/(\s+)/);
        parts.forEach((part) => {
          if (part.trim() === "") {
            frag.appendChild(document.createTextNode(part));
          } else {
            const span = document.createElement("span");
            span.className = "word";
            span.textContent = part;
            frag.appendChild(span);
          }
        });
        (child as ChildNode).replaceWith(frag);
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        walk(child);
      }
    });
  }

  walk(tmp);
  el.innerHTML = tmp.innerHTML;
  el.querySelectorAll<HTMLElement>(".word").forEach((w, i) => {
    w.style.transitionDelay = i * 0.05 + "s";
  });
}
